import React, { useEffect, useMemo, useRef, useState } from "react";
import Button from "../../../components/common/ui/Button";
import { useReactToPrint } from "react-to-print";
import { useDispatch, useSelector } from "react-redux";

import {
  authActions,
  facilityAction,
  masterActions,
  staffRequestAction,
} from "../../../_store";
import { Link, useLocation } from "react-router-dom";
import { showToastNotification } from "../../../components/common/ui/NotificationModal/ToastNotication";
import {
  CheckBoxInput,
  FileInput,
  RadioInput,
  SelectInput,
  TextAreaInput,
  TextInput,
} from "../../../components/common/ui/Inputs";
import CustomLoader from "../../../components/common/ui/Loader";
import { Popup } from "../../../components/common/ui/NotificationModal/Popup";
import {
  publicDefenderFormSchema,
  publicDefenderReject,
  publicDefenderSchema,
} from "../../../validation/staffRequestSchema";
import { history } from "../../../_helpers";
import { StoredProcedures, UserRoleType } from "../../../_helpers/enumerator";
import Table from "../../../components/common/table/Table";
import ExcelExport from "../../../components/common/ui/Export/ExcelExport";
import {
  formatDateTimeAMPM,
  getCurrentDate,
  getCurrentTime,
} from "../../../utils/formatTime";
import PdfViewer from "../../../components/common/PdfViewer/PdfViewer";
import generateXlsx from "../../../components/common/export/generateXlsx";
//import useTranslate from "../../../utils/useTranslation";
import translateText from "../../../_helpers/GoogleTranslator";
import DefenderFormHeader from "./DefenderFormHeader";
import { handleReviewRequestFormNavigation } from "./ReviewRequestFormNavigator";
import { getStoredValue } from "../../../_helpers/storagehelper";

function PublicDefenderForm() {
  const componentRef = useRef();
  const componentRef1 = useRef();
  const componentRef2 = useRef();
  const dispatch = useDispatch();
  const location = useLocation();

  const [showThreadListTable, setShowThreadListTable] = useState(true);
  const formID = location?.state ? location?.state?.formID : 0;

  const sourceFrom = location?.state ? location?.state?.sourceFrom : "";

  const facilityCode = useSelector((x) => x?.auth?.commonFacilityCode);

  const { ManagementUserID, UserRoleID, UserName, FullName } = useSelector(
    (x) => x?.auth?.user
  );
  const MAX_FILE_SIZE = parseInt(process.env.REACT_APP_MAX_FILESIZE, 10);
  //const { translatedMessages, translateMessages } = useTranslate();
  const [transLoader, setTransLoader] = useState(false);
  const [selectLang, setselectLang] = useState("");
  const [updateRequestColumn, setUpdateRequestColumn] = useState([]);
  const [updatePostByColumn, setUpdatePostByColumn] = useState([]);
  const [requestFormSubmitted, setRequestFormSubmitted] = useState(false);
  // const [requestFormTypeID, setRequestFormTypeID] = useState(formID);

  // const [requestFormData, setRequestFormData] = useState({
  //   folderPath: "",
  //   filename: "",
  //   file: "",
  //   pRequestFormTypeID: formID,
  //   facilityID: facilityCode,
  //   facilityCode: "",
  //   inmatesId: 0,
  //   managementUserID: ManagementUserID,
  //   postByInmate: 0,
  //   postByMuUser: 1,
  //   activeStatus: 0,
  //   pdFormPostBody: "",
  //   pdfAttachPath: "",
  //   postType: 1,
  // });
  const [facilityName, setFacilityName] = useState("");
  const [pdfdata, setpdfdata] = useState(null);

  const [requestFormTable, setRequestFormTable] = useState({
    formID: formID,
    pageNo: 1,
    rowCountPerPage: 10,
  });
  // const [formType, setFormType] = useState(1);
  const [errorMessage, setErrorMessage] = useState({});
  const [showRejectReasonTextInput, setShowRejectReasonTextInput] =
    useState(false);

  const [RejectReasonTxt, setRejectReasonTxt] = useState("");

  const {
    requestReview,
    publicDefenderList,
    publicDefenderDetailsResponse,
    AssignResponse,
    selfAssignResponse,
    GetPublicDefenderUserDropDownResponse,
    RequestPDAssignAcceptOrRejectResponse,
    // submitRequestFormInfoResponse,
    indexValue,
    loadInmateRequestFormList,
    LoadInmateRequestPublicDefenderThreadPostResponse,
    PublicDefenderThreadRespondResponse,
    publicDefenderFormPayloadData,
    staffRequestDefenderSearchList,
    loading,
  } = useSelector((x) => x?.staffRequest);

  const { ReplyMode } = useSelector((x) => x.dropdownOptions);

  // const { facilityDetails } = useSelector((x) => x?.facility);
  const { GetFacilityStaffReqInfoResponse, loading: facilityLoader } =
    useSelector((x) => x?.facility);

  const [publicDefenderID, setPublicDefenderID] = useState(0);
  const [publicDefenderName, setPublicDefenderName] = useState(0);

  const [showApproveRejectBtn, setShowApproveRejectBtn] = useState(false);
  const [showPDConversation, setShowPDConversation] = useState(false);
  const [showFirstPDConversation, setShowFirstPDConversation] = useState(false);
  const [showAssignedStaff, setShowAssignedStaff] = useState(false);
  const [assignedByLabel, setAssignedByLabel] = useState("");
  const [showAssignedBy, setShowAssignedBy] = useState(false);
  const [showAcceptanceStatus, setShowAcceptanceStatus] = useState(false);
  const [showPublicDefender, setShowPublicDefender] = useState(false);
  const [showAssignBtn, setshowAssignBtn] = useState(false);
  const [showSelfAssignBtn, setShowSelfAssignBtn] = useState(false);
  const [showReplyModal, setShowReplyModal] = useState(false);
  const [rejectedReason, setRejectedReason] = useState(false);
  const [showResponseDate, setShowResponseDate] = useState(false);
  const [showRejectedBy, setShowRejectedBy] = useState(false);
  const [showFormStatus, setShowFormStatus] = useState(false);
  const [submittedFormList, setSubmittedFormList] = useState([]);

  // const InmateResidentId = location?.state
  //   ? location?.state?.InmateResidentId
  //   : 0;
  const InmateID = location?.state ? location?.state?.InmateID : 0;
  const formDetails = location?.state ? location?.state?.formDetails : {};

  const prevFacilityCodeRef = useRef(facilityCode);

  useEffect(() => {
    if (formID) {
      setShowSelfAssignBtn(false);
      getPublicDefenderDetails();

      dispatch(
        staffRequestAction.LoadInmateRequestPublicDefenderThreadPost({
          noticesId: formID,
          isInmate: 0,
          isMGUser: 1,
          managementUserID: ManagementUserID,
          RowCountPerPage: requestFormTable.rowCountPerPage,
          PageNo: requestFormTable?.pageNo,
        })
      ).then((response) => {
        handleTranslate(selectLang, response?.payload);
      });
    }
    else {
      history?.navigate("/Admin/StaffRequestList");
    }
  }, [indexValue, formID, requestFormTable?.pageNo, requestFormTable.rowCountPerPage]);

  useEffect(() => {
    dispatch(
      masterActions.GetPublicDefenderNotificationAlert({
        ManagementUserID: ManagementUserID,
        FacilityID: facilityCode,
      })
    ).then((response) => {
      const updatedMenuList =
        getStoredValue("menu_list") || response?.payload;

      if (updatedMenuList) {
        dispatch(authActions.updateMenuList(updatedMenuList));
      }
    });

    dispatch(
      staffRequestAction?.getInmateMessageCount({
        FacilityCode: facilityCode,
        ManagementUserID: ManagementUserID,
      })
    );
  }, []);

  useEffect(() => {
    if (prevFacilityCodeRef.current !== facilityCode) {
      history.navigate(sourceFrom);
    }
  }, [facilityCode]);

  useEffect(() => {
    dispatch(
      staffRequestAction?.GetPublicDefenderUserDropDown({
        facilityId: facilityCode,
      })
    );
  }, [indexValue, formID, facilityCode]);

  useEffect(() => {
    dispatch(
      facilityAction?.GetFacilityStaffReqInfo({
        facilityID: facilityCode,
      })
    );
  }, [formID]);

  /* Assign */
  useEffect(() => {
    switch (AssignResponse?.IsSucceed) {
      case 1:
        showToastNotification(
          `Form assigned to "${publicDefenderName}" successfully`,
          "success"
        );

        dispatch(staffRequestAction?.resetForm());
        if (!requestReview) {
          history?.navigate("/Admin/StaffRequestList");
        }
        const formList = [...submittedFormList];
        formList.push(formID);
        setSubmittedFormList(formList);
        // setRequestFormSubmitted(true);
        if (requestReview) {
          const searchData = { ...staffRequestDefenderSearchList };
          searchData.FacilityID = facilityCode;
          searchData.ManagementUserID = ManagementUserID;
          searchData.ActiveStatus =
            searchData.ActiveStatus === 3 ? 2 : searchData.ActiveStatus;
          searchData.PageNo = 1;
          searchData.RowCountPerPage = publicDefenderList?.TotalRecordCount;
          dispatch(
            staffRequestAction?.PublicDefenderRequestReviewList(searchData)
          )
            .then((result) => {
              if (result?.payload?.DataList?.length > 0) {
                const data = result?.payload;
                handleReviewRequestFormNavigation(
                  "next",
                  data,
                  indexValue,
                  history,
                  sourceFrom,
                  dispatch
                );
                setPublicDefenderID(0); //reset public defender select box value
              } else {
                history?.navigate("/Admin/StaffRequestList");
              }
            })
            .catch((err) => {
              showToastNotification(err?.message, "error");
            });

          //updating notification
          dispatch(
            masterActions.GetLoadNotificationAlert({
              ManagementUserID: ManagementUserID,
              FacilityID: facilityCode,
            })
          )
            .then((response) => {
              const updatedMenuList =
                getStoredValue("menu_list") ||
                response?.payload;

              if (updatedMenuList) {
                dispatch(authActions.updateMenuList(updatedMenuList));
              }
            })
            .then((x) => {
              dispatch(
                masterActions.GetPublicDefenderNotificationAlert({
                  ManagementUserID: ManagementUserID,
                  FacilityID: facilityCode,
                })
              ).then((response) => {
                const updatedMenuList =
                  getStoredValue("menu_list") ||
                  response?.payload;

                if (updatedMenuList) {
                  dispatch(authActions.updateMenuList(updatedMenuList));
                }
              });
            });
        }
        break;

      case -2:
        showToastNotification(
          `"${publicDefenderName}" is not a valid Public Defender.`,
          "warning"
        );
        dispatch(staffRequestAction?.resetForm());
        break;

      case -3:
        showToastNotification(
          "This form already assigned to another Public Defender.",
          "warning"
        );
        dispatch(staffRequestAction?.resetForm());
        break;

      case -1:
        showToastNotification("Operation failed.", "error");
        dispatch(staffRequestAction?.resetForm());
        break;

      default:
        break;
    }
  }, [AssignResponse]);

  /* Self Assign */
  useEffect(() => {
    switch (selfAssignResponse?.IsSucceed) {
      case 1:
        //api call

        dispatch(
          staffRequestAction?.RequestPDAssignAcceptOrReject({
            requestForumThreadID:
              publicDefenderDetailsResponse?.RequestPublicDefenderThreadID,
            facilityID: facilityCode,
            managementUserID: ManagementUserID,
            PDStaffAssignAccept: 1,
            PDStaffAssignReject: 0,
            PDRequestRejectReason: "",
          })
        )
          .then((result) => {
            if (result?.payload) {
              dispatch(staffRequestAction?.resetForm());
            }
          })
          .catch((err) => { });

        //updating notification
        dispatch(
          masterActions.GetLoadNotificationAlert({
            ManagementUserID: ManagementUserID,
            FacilityID: facilityCode,
          })
        )
          .then((response) => {
            const updatedMenuList =
              getStoredValue("menu_list") ||
              response?.payload;

            if (updatedMenuList) {
              dispatch(authActions.updateMenuList(updatedMenuList));
            }
          })
          .then((x) => {
            dispatch(
              masterActions.GetPublicDefenderNotificationAlert({
                ManagementUserID: ManagementUserID,
                FacilityID: facilityCode,
              })
            ).then((response) => {
              const updatedMenuList =
                getStoredValue("menu_list") ||
                response?.payload;

              if (updatedMenuList) {
                dispatch(authActions.updateMenuList(updatedMenuList));
              }
            });
          });

        showToastNotification(
          "Form assigned to yourself successfully",
          "success"
        );
        // dispatch(staffRequestAction?.resetForm());
        history.navigate(
          "StaffRequestList/PublicDefenderForm/PublicDefenderRequestForm",
          {
            state: {
              noticeID:
                publicDefenderDetailsResponse?.RequestPublicDefenderThreadID,
              InmateID: publicDefenderDetailsResponse?.InmateID,
              RequestFormType:
                publicDefenderDetailsResponse?.RequestFormType ===
                  "Public Defender Form"
                  ? 53
                  : 0,
              formID:
                publicDefenderDetailsResponse?.RequestPublicDefenderThreadID,
              formDetails: formDetails,
            },
          }
        );
        // dispatch(staffRequestAction?.resetForm());
        break;

      case -2:
        showToastNotification(
          "Self Assign? not a valid Public Defender.",
          "warning"
        );
        dispatch(staffRequestAction?.resetForm());
        break;

      case -3:
        showToastNotification(
          "This form already assigned to another Public Defender.",
          "warning"
        );
        dispatch(staffRequestAction?.resetForm());
        break;

      case -1:
        showToastNotification("'Operation failed.", "error");
        dispatch(staffRequestAction?.resetForm());
        break;

      default:
        break;
    }
  }, [selfAssignResponse]);

  //load facility drop down
  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({
        facilityID: 0,
        activeStatus: 1,
      })
    )
      .then((data) => {
        const facilityList = data?.payload;
        const facilityName = facilityList?.find(
          (x) => x?.value === facilityCode
        )?.label;
        setFacilityName(facilityName);
      })
      .catch(() => {
        setFacilityName("");
      });
  }, []);

  useEffect(() => {
    switch (RequestPDAssignAcceptOrRejectResponse?.IsSucceed) {
      case 1:
        showToastNotification("Assigned PD-Form Accepted.", "success");
        dispatch(
          staffRequestAction?.publicDefenderDetails({
            formId: formID,
            ManagementUserID: ManagementUserID,
            FacilityCode: facilityCode,
          })
        );
        dispatch(staffRequestAction?.resetForm());
        getPublicDefenderDetails();
        // if (
        //   publicDefenderDetailsResponse?.IsAssignToPDUser === 1 &&
        //   publicDefenderDetailsResponse?.PDStaffAcceptAssignReqest === 1 &&
        //   publicDefenderDetailsResponse?.PDStaffRejectAssignReqest === 0
        // ) {
        dispatch(
          staffRequestAction.LoadInmateRequestPublicDefenderThreadPost({
            noticesId: formID,
            isInmate: 0,
            isMGUser: 1,
            managementUserID: ManagementUserID,
            RowCountPerPage: requestFormTable.rowCountPerPage,
            PageNo: requestFormTable?.pageNo,
          })
        );

        // if (requestReview) {
        //   const searchData = { ...staffRequestDefenderSearchList };
        //   searchData.FacilityID = facilityCode;
        //   searchData.ManagementUserID = ManagementUserID;
        //   searchData.ActiveStatus =
        //     searchData.ActiveStatus === 3 ? 2 : searchData.ActiveStatus;
        //   searchData.PageNo = 1;
        //   searchData.RowCountPerPage = publicDefenderList?.TotalRecordCount;
        //   dispatch(
        //     staffRequestAction?.PublicDefenderRequestReviewList(searchData)
        //   )
        //     .then((result) => {
        //       if (result?.payload?.DataList?.length > 0) {
        //         const data = result?.payload;
        //         handleReviewRequestFormNavigation(
        //           "next",
        //           data,
        //           indexValue,
        //           history,
        //           sourceFrom,
        //           dispatch
        //         );
        //         // setIsFormRejected(false);
        //       } else {
        //         history?.navigate("/Admin/StaffRequestList");
        //       }
        //     })
        //     .catch((err) => {
        //       showToastNotification(err?.message, "error");
        //     });
        // }

        break;

      case 2:
        showToastNotification("Assigned PD-Form Rejected", "success");
        dispatch(staffRequestAction?.resetForm());
        const formList = [...submittedFormList];
        formList.push(formID);
        setSubmittedFormList(formList);

        if (requestReview) {
          const searchData = { ...staffRequestDefenderSearchList };
          searchData.FacilityID = facilityCode;
          searchData.ManagementUserID = ManagementUserID;
          searchData.ActiveStatus =
            searchData.ActiveStatus === 3 ? 2 : searchData.ActiveStatus;
          searchData.PageNo = 1;
          searchData.RowCountPerPage = publicDefenderList?.TotalRecordCount;
          dispatch(
            staffRequestAction?.PublicDefenderRequestReviewList(searchData)
          )
            .then((result) => {
              if (result?.payload?.DataList?.length > 0) {
                const data = result?.payload;
                handleReviewRequestFormNavigation(
                  "next",
                  data,
                  indexValue,
                  history,
                  sourceFrom,
                  dispatch
                );
                setShowRejectReasonTextInput(false);
              } else {
                history?.navigate("/Admin/StaffRequestList");
              }
            })
            .catch((err) => {
              showToastNotification(err?.message, "error");
            });
        }

        if (!requestReview) {
          history?.navigate("/Admin/StaffRequestList");
        }
        break;

      case -1:
        showToastNotification("Operation Failed.", "error");
        dispatch(staffRequestAction?.resetForm());
        break;

      case -2:
        showToastNotification("Not a valid public defender user.", "error");
        dispatch(staffRequestAction?.resetForm());
        break;

      case -3:
        showToastNotification(
          "Already this form has Accept or Reject by public defender staff user .",
          "error"
        );
        dispatch(staffRequestAction?.resetForm());
        break;

      default:
        break;
    }
  }, [RequestPDAssignAcceptOrRejectResponse]);

  useEffect(() => {
    switch (PublicDefenderThreadRespondResponse?.IsSucceed) {
      case 1:
        const searchData = { ...publicDefenderFormPayloadData };
        searchData.pdFormPostBody = "";
        searchData.pdfAttachPath = "";
        searchData.activeStatus = 0;
        searchData.postType = 1;
        dispatch(
          staffRequestAction?.updatePublicDefenderFormPayload(searchData)
        );

        dispatch(
          staffRequestAction.LoadInmateRequestPublicDefenderThreadPost({
            noticesId: formID,
            isInmate: 0,
            isMGUser: 1,
            managementUserID: ManagementUserID,
            RowCountPerPage: requestFormTable.rowCountPerPage,
            PageNo: requestFormTable?.pageNo,
          })
        )
          .then((result) => {
            if (result?.payload) {
              handleTranslate(selectLang, result?.payload);
            }
          })
          .catch((err) => {
            showToastNotification("Failed to get grid data", "error");
          });

        dispatch(
          staffRequestAction?.publicDefenderDetails({
            formId: formID,
            ManagementUserID: ManagementUserID,
            FacilityCode: facilityCode,
          })
        );

        dispatch(
          authActions?.ManagementUserActivityLog({
            ManagementUserID: ManagementUserID,
            facilityID: facilityCode ? facilityCode : 0,
            ProcedureName: StoredProcedures?.RequestPublicDefenderThreadRespond,
            UserAction: `MG User Responded to Inmate Request ( PRequestFormTypeID - ${formID} )`,
          })
        );
        //update notification count
        dispatch(
          masterActions.GetLoadNotificationAlert({
            ManagementUserID: ManagementUserID,
            FacilityID: facilityCode,
          })
        );

        dispatch(
          staffRequestAction?.UpdateMURequestRead({
            requestID: formID,
            requestFormTypeID:
              publicDefenderDetailsResponse?.RequestFormType ===
                "Public Defender Form"
                ? 53
                : 0,
            facilityID: facilityCode,
            createdBy: ManagementUserID,
          })
        );

        // dispatch(
        //   masterActions.GetPublicDefenderNotificationAlert({
        //     ManagementUserID: ManagementUserID,
        //     FacilityID: facilityCode,
        //   })
        // );

        dispatch(
          masterActions.GetPublicDefenderNotificationAlert({
            ManagementUserID: ManagementUserID,
            FacilityID: facilityCode,
          })
        ).then((response) => {
          const updatedMenuList =
            getStoredValue("menu_list") || response?.payload;

          if (updatedMenuList) {
            dispatch(authActions.updateMenuList(updatedMenuList));
          }
        });

        dispatch(staffRequestAction?.resetForm());
        dispatch(staffRequestAction?.resetPublicDefenderFormPayload());
        // getPublicDefenderDetails();
        setRequestFormSubmitted(true);
        showToastNotification("Form Submitted Successfully.", "success");
        break;

      case -1:
        showToastNotification("Operation Failed", "error");
        dispatch(staffRequestAction?.resetForm());
        break;

      case -2:
        showToastNotification("Public Defender Form Not Exist", "error");
        dispatch(staffRequestAction?.resetForm());
        break;

      case -3:
        showToastNotification(
          "Public Defender Form Not Assigned to public defender user or improper public defender user post request",
          "error"
        );
        dispatch(staffRequestAction?.resetForm());
        break;

      case -4:
        showToastNotification("Form Post is wrong value", "error");
        dispatch(staffRequestAction?.resetForm());
        break;

      case -5:
        showToastNotification("Post body empty or pdf path empty", "error");
        dispatch(staffRequestAction?.resetForm());
        break;

      default:
        break;
    }
  }, [PublicDefenderThreadRespondResponse]);

  const handleDownloadPDF = (e, row) => {
    e?.preventDefault();
    const splitFolderPath = row?.PdfDocAttachPath?.split("/");
    const folderPath =
      splitFolderPath[1] + "/" + splitFolderPath[2] + "/" + splitFolderPath[3] + "/" + splitFolderPath[4];
    const fileName = splitFolderPath[5];
    dispatch(
      staffRequestAction?.DownLoadFile({
        folderPath: folderPath,
        filename: fileName,
      })
    )
      .then((result) => {
        setpdfdata(result?.payload);
      })
      .catch((err) => {
        showToastNotification("Failed to view PDF", "error");
      });
  };

  const column = useMemo(
    () => [
      {
        name: "Request",
        width: "350px",
        selector: (row) => row.request,
        cell: (row, i) =>
          row.PostByInmate === 1 ? (
            <div div className="d-flex  gap-2 ">
              {/* <div className="d-flex flex-wrap gap-2">
              <i
                className="fa-solid fa-reply inmate-replied fs-3"
                aria-hidden="true"
                title="Inmate Replied"
              ></i>
              {row?.ForumPostBody}
            </div> */}
              <div className="d-flex gap-2">
                <i
                  className="fa-solid fa-reply inmate-replied fs-3"
                  aria-hidden="true"
                  title="Inmate Replied"
                ></i>
                <div
                  className="pre-wrap-text"
                  dangerouslySetInnerHTML={{
                    __html:
                      updateRequestColumn?.length > 0
                        ? updateRequestColumn[i]
                        : showmessagecontent(row?.ForumPostBody),
                  }}
                ></div>
              </div>
              {row?.PdfDocAttachPath && (
                <div className="d-flex align-items-center gap-2">
                  <Link
                    className="btn button-success btn-lg w-inherit cursor-pointer"
                    onClick={(e) => handleDownloadPDF(e, row)}
                  >
                    <i class="fa-solid fa-file-pdf me-2"></i>
                    View PDF
                  </Link>
                </div>
              )}
            </div>
          ) : (
            // Example "else if" condition
            <div div className="d-flex flex-wrap gap-2 align-items-start">
              {/* <div className="d-flex flex-wrap gap-2">
              <i
                className="fa-solid fa-user-shield admin-replied fs-3"
                aria-hidden="true"
                title="Admin Replied"
              />
              {row?.ForumPostBody}
            </div> */}

              <div className="d-flex  gap-2">
                <i
                  className="fa-solid fa-user-shield admin-replied fs-3"
                  aria-hidden="true"
                  title="Admin Replied"
                />
                <div
                  className="pre-wrap-text"
                  dangerouslySetInnerHTML={{
                    __html:
                      updateRequestColumn?.length > 0
                        ? updateRequestColumn[i]
                        : showmessagecontent(row?.ForumPostBody),
                  }}
                ></div>
              </div>
              {row?.PdfDocAttachPath && (
                <Link
                  className="btn button-success btn-lg w-inherit cursor-pointer"
                  onClick={(e) => handleDownloadPDF(e, row)}
                >
                  <i class="fa-solid fa-file-pdf me-2"></i>
                  View PDF
                </Link>
              )}
            </div>
          ),
        sortable: false,
      },

      {
        name: "Posted By",
        selector: (row) => row.ForumThreadPostBy,
        cell: (row, i) => (
          <div
            className="d-flex flex-wrap gap-2"
            dangerouslySetInnerHTML={{
              __html:
                updatePostByColumn?.length > 0
                  ? updatePostByColumn[i]
                  : showmessagecontent(row?.ForumThreadPostBy),
            }}
          ></div>
        ),
        sortable: false,
      },
      {
        name: "Sent Date Time",
        selector: (row) => formatDateTimeAMPM(row.ReqPostSendDate),
        sortable: false,
      },
    ],
    [
      updateRequestColumn,
      updatePostByColumn,
      LoadInmateRequestPublicDefenderThreadPostResponse?.DataList,
    ]
  );
  const getPublicDefenderDetails = () => {
    // if (formID > 0) {
    dispatch(
      staffRequestAction?.publicDefenderDetails({
        formId: formID,
        ManagementUserID: ManagementUserID,
        FacilityCode: facilityCode,
      })
    )
      .then((result) => {
        setShowReplyModal(false);
        setShowSelfAssignBtn(false);
        setShowApproveRejectBtn(false);
        setShowPDConversation(false);

        // setShowThreadListTable(true);
        const data = result?.payload;
        var assignedLabel = "";
        const dataList = { ...publicDefenderFormPayloadData };
        dataList.inmatesId = InmateID;
        dispatch(staffRequestAction?.updatePublicDefenderFormPayload(dataList));
        //condition start
        if (
          data?.ReqAssignToPDUser === ManagementUserID ||
          (data?.IsAssignToPDUser === 1 &&
            data?.PDStaffAcceptAssignReqest === 1 &&
            data?.IsAllowtoAccessOthersPDForm === true)
        ) {
          //first parent if
          if (
            (data?.IsAssignToPDUser === 1 &&
              data?.RequestAssignStatus !== "" &&
              UserRoleType?.PublicDefenderAdmin === UserRoleID) ||
            (UserRoleID === UserRoleType?.PublicDefender &&
              data?.IsAllowtoAccessOthersPDForm === true)
          ) {
            //second if
            setShowAssignedStaff(true);
            setShowFirstPDConversation(true);
            setShowAssignedBy(true);

            /* Acceptance Status */
            if (data?.PublicDefenderName !== data?.ManagementUserAssignByName) {
              setShowAcceptanceStatus(true);
            } else {
              setShowAcceptanceStatus(false);
            }

            if (
              data?.ManagementUserAssignByName === FullName &&
              data?.PublicDefenderName === FullName
            ) {
              setAssignedByLabel("Self");
              assignedLabel = "Self";
            } else if (
              data?.ManagementUserAssignByName === data?.PublicDefenderName &&
              data?.PublicDefenderName !== FullName
            ) {
              setAssignedByLabel(data?.ManagementUserAssignByName + " (Self) ");
              assignedLabel = data?.ManagementUserAssignByName + " (Self) ";
            } else {
              assignedLabel = data?.ManagementUserAssignByName;
              setAssignedByLabel(data?.ManagementUserAssignByName);
            }

            /* Assigned Staff */
            if (
              assignedLabel === "Self" &&
              data?.ReqAssignToPDUser === ManagementUserID
            ) {
              setShowAssignedStaff(false);
            }

            // else {
            //   setShowAssignedStaff(true);
            // }
          } else {
            //2nd else
            setShowAssignedStaff(false);
            setShowFirstPDConversation(false);
            setShowAssignedBy(false);
            setShowAcceptanceStatus(false);
          }

          setShowReplyModal(true);
          setShowThreadListTable(true);
          setShowPublicDefender(false);
          setRejectedReason(false);

          /* approve reject btn */
          if (
            data.IsAssignToPDUser === 1 &&
            data?.PDStaffAcceptAssignReqest === 1 &&
            data?.PDStaffRejectAssignReqest === 0
          ) {
            // setShowApproveRejectBtn(false);
            setShowPDConversation(false);
          } else {
            setRejectedReason(false);
            setShowReplyModal(false);
            setShowPDConversation(true);
            setShowApproveRejectBtn(true);
            setShowThreadListTable(false);
          }
        } else {
          setShowPDConversation(true);
          if (
            data?.IsAssignToPDUser === 1 &&
            data?.RequestAssignStatus !== "" &&
            UserRoleType?.PublicDefenderAdmin === UserRoleID
          ) {
            setShowAssignedStaff(true);
            setShowFirstPDConversation(true);
            setShowAssignedBy(true);

            if (data?.PublicDefenderName !== data?.ManagementUserAssignByName) {
              setShowAcceptanceStatus(true);
            } else {
              setShowAcceptanceStatus(false);
            }
            if (data?.PublicDefenderName !== data?.ManagementUserAssignByName) {
              setAssignedByLabel(data?.ManagementUserAssignByName);
            } else {
              setAssignedByLabel("Self");
            }

            if (
              assignedByLabel === "Self" &&
              data?.ReqAssignToPDUser === ManagementUserID
            ) {
              setShowAssignedStaff(false);
            }
            // else {
            //   setShowAssignedStaff(true);
            // }
          } else {
            setShowAssignedStaff(false);
            setShowFirstPDConversation(false);
            setShowAssignedBy(false);
            setShowAcceptanceStatus(false);
          }
          setShowThreadListTable(false);

          /* in future If they ask to work in this need to change  */
          // if (
          //   data?.PDStaffAcceptAssignReqest === 1 ||
          //   data?.PDStaffRejectAssignReqest === 1
          // ) {
          //   setShowResponseDate(true);
          // }

          // setRejectedReason(data?.PDStaffRejectAssignReqest === 1);

          // if (
          //   data?.PDStaffRejectAssignReqest === 1 &&
          //   data?.publicDefenderName !== ""
          // ) {
          //   setShowRejectedBy(true); //here
          // } else {
          //   setShowRejectedBy(false);
          // }

          if (data?.IsAssignToPDUser === 1) {
            if (
              (data?.PDStaffAcceptAssignReqest === 0 &&
                data?.PDStaffRejectAssignReqest === 0) ||
              data?.PDStaffAcceptAssignReqest === 1
            ) {
              setShowPDConversation(false);
              setShowPublicDefender(false);
              setshowAssignBtn(false);
              setShowSelfAssignBtn(false);
            } else {
              setShowPublicDefender(true);
              setShowPDConversation(true);
              setshowAssignBtn(true);
              setShowSelfAssignBtn(true);
            }
          } else {
            if (UserRoleID === UserRoleType?.PublicDefender) {
              setShowPublicDefender(false);
              setshowAssignBtn(false);
            } else {
              setshowAssignBtn(true);
              setShowPublicDefender(true);
            }
            setShowPDConversation(true);
            setShowSelfAssignBtn(true); //show btn here
          }
        }
      })
      .catch((err) => {
        showToastNotification(err?.message, "error");
      });
  };

  const handlePrints = useReactToPrint({
    pageStyle: `@media print {
      @page {
       size: A4 portrait;
        margin: 2 !important;
         padding: 2 !important;
      }
      body {
        height: auto !important;
        overflow: hidden !important;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }

      * {
        
        font-size: 16px !important;
      }

      table, th, td {
        border: 2px solid black !important;
      }

      .print-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        break-inside: avoid;
        page-break-inside: avoid;
      }

      .print-date {
        position: absolute;
        top: 10px;
        right: 20px;
        font-size: 14px;
        font-weight: bold;
      }

       .rdt_Pagination,
      .sc-diYFot jfOLQZ rdt_Pagination,
      .pagination-postion,
       .sc-diYFot,
       .jfOLQZ
        {
         display: none !important;
       }
    }
  `,
    content: () => {
      const combinedContent = document.createElement("div");
      if (componentRef2.current) {
        combinedContent.appendChild(componentRef2.current.cloneNode(true));
      }
      if (componentRef.current) {
        combinedContent.appendChild(componentRef.current.cloneNode(true));
      }
      if (componentRef1.current) {
        combinedContent.appendChild(componentRef1.current.cloneNode(true));
      }
      return combinedContent;
    },
    onBeforeGetContent: () => { },
  });

  const handlePublicDefenderChange = (e) => {
    setPublicDefenderID(e?.value);
    setPublicDefenderName(e?.label);
  };

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e?.target;
    const errorList = { ...errorMessage };
    delete errorList[name];
    setErrorMessage(errorList);

    if (type === "file" && files?.length === 0) {
      setErrorMessage((prev) => ({
        ...prev,
        [name]: "Please upload pdf document.",
      }));
      const data = { ...publicDefenderFormPayloadData };
      data["file"] = "";
      data["fileType"] = "";
      data["fileSize"] = 0;
      dispatch(staffRequestAction?.updatePublicDefenderFormPayload(data));
      // setRequestFormData(data);
      return;
    }
    if (type === "file" && files?.length > 0) {
      const fileType = files?.[0]?.type;
      const fileSize = files?.[0]?.size;
      if (fileSize > MAX_FILE_SIZE) {
        setErrorMessage((prev) => ({
          ...prev,
          [name]: "File size should not exceed 20MB.",
        }));
      }
      if (fileType !== "application/pdf") {
        setErrorMessage((prev) => ({
          ...prev,
          [name]: "Please select PDF Document.",
        }));
        const data = { ...publicDefenderFormPayloadData };
        data["file"] = "";
        data["fileType"] = fileType;
        data["fileSize"] = 0;
        dispatch(staffRequestAction?.updatePublicDefenderFormPayload(data));
        // setRequestFormData(data);
        return;
      }
      // setErrorMessage({});
      const reader = new FileReader();
      reader.onloadend = () => {
        let formData = { ...publicDefenderFormPayloadData };
        const fileName = files[0]?.name;
        const lastIndex = fileName?.lastIndexOf(".");
        const removedExtensionTxt = [...fileName]
          .splice(0, lastIndex)
          .toString();
        const removeWhitSpace = removedExtensionTxt.replace(
          /[+\-\/,?*:;<>@#$%^&!~\s]/g,
          ""
        );
        const removedExtraTxt = [...removeWhitSpace].splice(0, 100).join(""); //retutn only 100 characters
        const currentDate = getCurrentDate()?.split("/").join("");
        const currentTime = getCurrentTime().split(":").join("");
        const now = new Date();
        // const timestamp = now.getFullYear().toString() +
        //   String(now.getMonth() + 1).padStart(2, "0") +
        //   String(now.getDate()).padStart(2, "0") +
        //   String(now.getHours()).padStart(2, "0") +
        //   String(now.getMinutes()).padStart(2, "0") +
        //   String(now.getSeconds()).padStart(2, "0");
        formData["file"] = reader.result.split(",")[1];
        formData["fileType"] = files?.[0]?.type;
        formData["fileSize"] = files?.[0]?.size;
        formData["filename"] = removedExtraTxt;
        // formData["facilityCode"] = facilityName;
        formData["facilityCode"] =
          GetFacilityStaffReqInfoResponse?.FacilityName;
        dispatch(staffRequestAction?.updatePublicDefenderFormPayload(formData));
        // setRequestFormData(formData);
      };
      reader.readAsDataURL(files[0]);
    }
    const formData = { ...publicDefenderFormPayloadData };
    if (type === "radio") {
      setErrorMessage({});
      formData[name] = parseInt(value);
      formData["pdFormPostBody"] = "";
      formData["file"] = "";
      formData["filename"] = "";
      formData["fileType"] = "";
      formData["fileSize"] = 0;
      const fileInput = document.getElementById("fileInput");
      if (fileInput) {
        fileInput.value = "";
      }
    }

    if (type === "checkbox") {
      formData[name] = checked ? 1 : 0;
    }

    if (type === "textarea") {
      if (/^\s/.test(value)) return;
      formData[name] = value;
    }
    dispatch(staffRequestAction?.updatePublicDefenderFormPayload(formData));
    // setRequestFormData(formData);
  };

  // const handleValidation = (e, name) => {
  //   const requestData = { ...publicDefenderFormPayloadData };
  //   const file = { type: requestData?.fileType, size: requestData?.fileSize };
  //   requestData.file = file;
  //   const { error } = publicDefenderFormSchema(requestData);
  //   if (error?.details) {
  //     error?.details?.map((e) => {
  //       const { path } = e;
  //       setErrorMessage((prev) => ({
  //         ...prev,
  //         [path[0]]: e?.message,
  //       }));
  //     });
  //     return;
  //   }
  //   const fieldError = error?.details?.find(
  //     (e) => e?.path?.toString() === name
  //   );
  //   const element = document.querySelector(`[name="${name}"]`);
  //   if (element) {
  //     if (fieldError) {
  //       element.classList.add("input-error");
  //     } else {
  //       element.classList.remove("input-error");
  //     }
  //   }
  // };

  const handleValidation = (e, name) => {
    const requestData = { ...publicDefenderFormPayloadData };
    const file = { type: requestData?.fileType, size: requestData?.fileSize };
    requestData.file = file;
    const { error } = publicDefenderFormSchema(requestData);
    if (error?.details) {
      const fieldError = error.details.find((e) => e.path.toString() === name);
      if (fieldError && Object?.keys(fieldError)?.length > 0) {
        setErrorMessage((prev) => ({
          ...prev,
          [name]: fieldError ? fieldError.message : "",
        }));
      }
      return;
    }
    const fieldError = error?.details?.find(
      (e) => e?.path?.toString() === name
    );
    const element = document.querySelector(`[name="${name}"]`);
    if (element) {
      if (fieldError) {
        element.classList.add("input-error");
      } else {
        element.classList.remove("input-error");
      }
    }
  };

  const handleFormReset = () => {
    setErrorMessage({});
    // const data = { ...publicDefenderFormPayloadData };
    // data.pdFormPostBody = "";
    // data.postType = 1;
    // data.activeStatus = 0;
    dispatch(staffRequestAction?.resetPublicDefenderFormPayload());
    // setRequestFormData({
    //   ...publicDefenderFormPayloadData,
    // pdFormPostBody: "",
    // postType: 1,
    // activeStatus: 0,
    // });
  };
  const showmessagecontent = (Value) => {
    const highlightedMessageContent = `<span >${Value}</span>`;
    return highlightedMessageContent;
  };

  const handleTranslate = async (
    language,
    data = LoadInmateRequestPublicDefenderThreadPostResponse
  ) => {
    setselectLang(language);
    setTransLoader(true);
    const request = data?.DataList.map((msg) => msg.ForumPostBody);
    const postBy = data?.DataList.map((msg) => msg.ForumThreadPostBy);
    // const translatedRequest = await translateText(request, language);
    // const translatedPostBy = await translateText(postBy, language);

    const translatedRequest =
      language === "es" || language === "en" ? await translateText(request, language) : request;
    const translatedPostBy =
      language === "es" || language === "en" ? await translateText(postBy, language) : postBy;

    const requestColumn = translatedRequest?.map((text) => {
      return `<span>${text}</span>`;
    });
    const posyByColumn = translatedPostBy?.map((text) => {
      return `<span>${text}</span>`;
    });
    setUpdateRequestColumn(requestColumn);
    setUpdatePostByColumn(posyByColumn);
    setTransLoader(false);
  };

  useEffect(() => {
    handleTranslate(selectLang)
  }, [selectLang])

  const submitRequestFormInfo = () => {
    const requestData = { ...publicDefenderFormPayloadData };
    const file = { type: requestData?.fileType, size: requestData?.fileSize };
    requestData.file = file;
    if (requestData?.activeStatus != 1) {
      const { error } = publicDefenderFormSchema(requestData);
      setErrorMessage({});
      if (error?.details) {
        error?.details?.map((e) => {
          const { path } = e;
          setErrorMessage((prev) => ({
            ...prev,
            [path[0]]: e?.message,
          }));
        });
        return;
      }

      if (Object?.keys(errorMessage)?.length > 0) return;
    }
    const payload = { ...publicDefenderFormPayloadData };
    payload.inmatesId = InmateID;
    payload.requestForumThreadID = formID;
    payload.pRequestFormTypeID = formID;
    payload.facilityID = facilityCode;
    payload.managementUserID = ManagementUserID;
    dispatch(staffRequestAction?.PublicDefenderThreadRespond(payload));
    dispatch(staffRequestAction?.updatePublicDefenderFormPayload(payload));
  };

  const handleAccept = () => {
    Popup({
      title: "Message",
      text: `Do you want to Accept this request..?`,
      icon: "info",
      confirmButtonText: "Ok",
      cancelButtonText: "Cancel",
      onConfirm: () => {
        dispatch(
          staffRequestAction?.RequestPDAssignAcceptOrReject({
            requestForumThreadID:
              publicDefenderDetailsResponse?.RequestPublicDefenderThreadID,
            pRequestFormTypeID:
              publicDefenderDetailsResponse?.RequestPublicDefenderThreadID,
            facilityID: facilityCode,
            managementUserID: ManagementUserID,
            PDStaffAssignAccept: 1,
            PDStaffAssignReject: 0,
            PDRequestRejectReason: "",
          })
        )
          .then((result) => {
            if (result?.payload) {
              getPublicDefenderDetails();
              dispatch(staffRequestAction?.resetForm());
            }
          })
          .catch((err) => {
            showToastNotification(err?.message, "error");
          });

        //updating notification
        dispatch(
          masterActions.GetLoadNotificationAlert({
            ManagementUserID: ManagementUserID,
            FacilityID: facilityCode,
          })
        )
          .then((response) => {
            const updatedMenuList =
              getStoredValue("menu_list") ||
              response?.payload;

            if (updatedMenuList) {
              dispatch(authActions.updateMenuList(updatedMenuList));
            }
          })
          .then((x) => {
            dispatch(
              masterActions.GetPublicDefenderNotificationAlert({
                ManagementUserID: ManagementUserID,
                FacilityID: facilityCode,
              })
            ).then((response) => {
              const updatedMenuList =
                getStoredValue("menu_list") ||
                response?.payload;

              if (updatedMenuList) {
                dispatch(authActions.updateMenuList(updatedMenuList));
              }
            });
          });
      },
    });
  };

  const handleReject = () => {
    Popup({
      title: "Message",
      text: `Do you want to Reject this request..?`,
      icon: "info",
      confirmButtonText: "Ok",
      cancelButtonText: "Cancel",
      onConfirm: () => {
        setShowRejectReasonTextInput(true);

        //updating notification
        dispatch(
          masterActions.GetLoadNotificationAlert({
            ManagementUserID: ManagementUserID,
            FacilityID: facilityCode,
          })
        )
          .then((response) => {
            const updatedMenuList =
              getStoredValue("menu_list") ||
              response?.payload;

            if (updatedMenuList) {
              dispatch(authActions.updateMenuList(updatedMenuList));
            }
          })
          .then((x) => {
            dispatch(
              masterActions.GetPublicDefenderNotificationAlert({
                ManagementUserID: ManagementUserID,
                FacilityID: facilityCode,
              })
            ).then((response) => {
              const updatedMenuList =
                getStoredValue("menu_list") ||
                response?.payload;

              if (updatedMenuList) {
                dispatch(authActions.updateMenuList(updatedMenuList));
              }
            });
          });
      },
    });
  };

  const handleRejectReasonChanges = (e) => {
    const { value } = e?.target;
    setRejectReasonTxt(value);
  };

  const submitRejectReason = () => {
    //validation
    const { error } = publicDefenderReject({
      PDRequestRejectReason: RejectReasonTxt,
    });
    setErrorMessage({});
    if (error?.details) {
      error?.details?.map((e) => {
        const { path } = e;
        setErrorMessage((prev) => ({
          ...prev,
          [path.join(".")]: e?.message,
        }));
      });
      return;
    }
    dispatch(
      staffRequestAction?.RequestPDAssignAcceptOrReject({
        requestForumThreadID:
          publicDefenderDetailsResponse?.RequestPublicDefenderThreadID,
        pRequestFormTypeID:
          publicDefenderDetailsResponse?.RequestPublicDefenderThreadID,
        facilityID: facilityCode,
        managementUserID: ManagementUserID,
        PDStaffAssignAccept: 0,
        PDStaffAssignReject: 1,
        PDRequestRejectReason: RejectReasonTxt,
      })
    )
      .then((result) => {
        if (result?.payload) {
          getPublicDefenderDetails();
        }
      })
      .catch((err) => { });
  };

  const handleAssign = () => {
    //validation
    const { error } = publicDefenderSchema({
      publicDefenderUserId: publicDefenderID,
    });

    if (error?.details) {
      Popup({
        title: "Message",
        text: `${error?.details[0]?.message}`,
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }
    Popup({
      title: "Message",
      text: `Are you sure you want to assign this form to "${publicDefenderName}"..?`,
      icon: "info",
      confirmButtonText: "Ok",
      cancelButtonText: "Cancel",
      onConfirm: () => {
        dispatch(
          staffRequestAction?.Assign({
            pRequestFormTypeId:
              publicDefenderDetailsResponse?.RequestPublicDefenderThreadID,
            facilityId: facilityCode,
            createdBy: ManagementUserID,
            publicDefenderUserId: publicDefenderID,
          })
        );
      },
    });
  };

  const handleSelfAssign = () => {
    Popup({
      title: "Message",
      text: `Are you sure you want to assign this form to "Yourself"`,
      icon: "info",
      confirmButtonText: "Ok",
      cancelButtonText: "Cancel",
      onConfirm: () => {
        dispatch(
          staffRequestAction?.selfAssign({
            pRequestFormTypeId:
              publicDefenderDetailsResponse?.RequestPublicDefenderThreadID,
            facilityId: facilityCode,
            createdBy: ManagementUserID,
            publicDefenderUserId: ManagementUserID,
          })
        )
          .then((result) => {
            if (result?.payload) {
              dispatch(staffRequestAction?.resetForm());
            }
          })
          .catch((err) => {
            showToastNotification(err?.message, "error");
          });
      },
    });
  };

  const handleRowPerPage = (page) => {
    setRequestFormTable((prevState) => ({
      ...prevState,
      rowCountPerPage: page,
      pageNo: 1
    }));
  };

  const handlePageChange = (page) => {
    setRequestFormTable((prevState) => ({
      ...prevState,
      pageNo: page,
    }));
  };

  const exportRequestForm = async () => {
    let generateExcelColumns = ["Request", "Posted By", "Send Date time"];
    const updateTotalRows = {
      ...requestFormTable,
      rowCountPerPage: loadInmateRequestFormList?.TotalRecordCount,
      exportExcel: true,
      pageNo: 1,
    };

    try {
      const result = await dispatch(
        staffRequestAction.LoadInmateRequestPublicDefenderThreadPost({
          noticesId: formID,
          isInmate: 0,
          isMGUser: 1,
          managementUserID: ManagementUserID,
          RowCountPerPage: LoadInmateRequestPublicDefenderThreadPostResponse?.TotalRecordCount,
          PageNo: 1,
          isExcelExport: true,
        })
      );

      const dataList = result?.payload?.DataList || [];

      const exportData = await Promise.all(
        dataList.map(async (obj) => {
          const translatedRequest =
            obj?.IsAttachDocPDF === 1 && obj?.IsPostText === 1
              ? (selectLang == "en" || selectLang == "es" ? (await translateText(obj.ForumPostBody, selectLang)) : obj.ForumPostBody) +
              " (Replied as PDF)"
              : obj?.IsAttachDocPDF === 1
                ? "(Replied as PDF)"
                : (selectLang == "en" || selectLang == "es" ? await translateText(obj.ForumPostBody, selectLang) : obj.ForumPostBody);
          const translatedPostedBy = (selectLang == "en" || selectLang == "es" ? await translateText(
            obj.ForumThreadPostBy,
            selectLang
          ) : obj.ForumThreadPostBy);
          return {
            Request: translatedRequest,
            "Posted By": translatedPostedBy,
            "Send Date time": formatDateTimeAMPM(obj.ReqPostSendDate),
          };
        })
      );

      generateXlsx(exportData, generateExcelColumns, "Forum_List");
    } catch (err) {
      showToastNotification("Error in Export Data", "error");
    }
  };

  if (loading || facilityLoader || transLoader) return <CustomLoader />;

  return (
    <div className="card shadow-sm b-r-all  p-4 border border-dark-grey mt-3 me-3 w-100">
      {pdfdata && (
        <div className="d-flex flex-wrap justify-content-end gap-3">
          <Button
            label="Back"
            type="button"
            icon={"fa-solid fa-angle-left"}
            status="primary"
            onClick={() => {
              setpdfdata(null);
            }}
          />
        </div>
      )}

      {pdfdata ? (
        <PdfViewer data={`data:application/pdf;base64,${pdfdata}`} />
      ) : (
        <div>
          <DefenderFormHeader
            list={formDetails}
            requestReview={requestReview}
            handlePrints={handlePrints}
            errorMessage={errorMessage}
            setErrorMessage={setErrorMessage}
            setPublicDefenderID={setPublicDefenderID}
            setShowRejectReasonTextInput={setShowRejectReasonTextInput}
            requestFormSubmitted={requestFormSubmitted}
            setRequestFormSubmitted={setRequestFormSubmitted}
          />

          <div className="request-remedy-form">
            <div className="">
              <form>
                {/* <div className="innerContent" ref={componentRef}> */}
                <div className="">
                  <article>
                    <div ref={componentRef2}>
                      <div className="d-flex flex-wrap align-items-center profile-row mb-4">
                        <div className="d-flex req-header-img">
                          {GetFacilityStaffReqInfoResponse?.LogoFile && (
                            <img
                              src={
                                "data:image/png;base64," +
                                GetFacilityStaffReqInfoResponse?.LogoFile
                              }
                              alt="facility-logo"
                              className="req-img"
                            />
                          )}
                        </div>
                        <div className="justify-content-center align-items-center req-header-title">
                          <h3 className="text-color py-2 text-center">
                            <span className="label-red req-text">
                              {GetFacilityStaffReqInfoResponse?.FacilityName?.toUpperCase()}
                            </span>
                          </h3>
                        </div>
                      </div>
                      <h4
                        className="request-form-header text-color mt-4"
                        style={{ cursor: "pointer" }}
                      >
                        <i className="fa-solid fa-circle-info me-2"></i> PUBLIC
                        DEFENDER FORM
                      </h4>
                    </div>
                    <div
                      ref={componentRef}
                      className="row border-bottom-1 request-form-card details-legal"
                    >
                      <h4
                        className="request-form-header text-color mt-4"
                        style={{ cursor: "pointer" }}
                      >
                        <i className="fa-solid fa-circle-info me-2"></i> REQUEST
                        INFO
                      </h4>
                      {[
                        {
                          label: "Title",
                          value:
                            publicDefenderDetailsResponse?.PublicDefenderThreadTitle,
                        },
                        {
                          label: "Inmate ID",
                          value:
                            publicDefenderDetailsResponse?.InmateResidentId,
                        },
                        {
                          label: "Inmate Name",
                          value: publicDefenderDetailsResponse?.InmateFullName,
                        },
                        {
                          label: "Created On",
                          value:
                            publicDefenderDetailsResponse?.RequestCreateDate,
                        },
                        {
                          label: "POD",
                          value: publicDefenderDetailsResponse?.PodCode
                            ? publicDefenderDetailsResponse?.PodCode
                            : "-",
                        },

                        ...(showFirstPDConversation
                          ? [
                            {
                              label: "PD Conversation",
                              value:
                                publicDefenderDetailsResponse?.PDConversation,
                            },
                          ]
                          : []),

                        ...(showAssignedBy
                          ? [
                            {
                              label: "Assigned By",
                              value: assignedByLabel,
                            },
                          ]
                          : []),

                        ...(showAssignedStaff
                          ? [
                            {
                              label: "Assigned staff",
                              value:
                                publicDefenderDetailsResponse?.PublicDefenderName,
                            },
                          ]
                          : []),

                        ...(showAcceptanceStatus
                          ? [
                            {
                              label: "Acceptance Status",
                              value:
                                publicDefenderDetailsResponse?.RequestAssignStatus,
                            },
                          ]
                          : []),
                      ].map((item, index) => (
                        <div key={index} className="col-sm-12 col-md-6">
                          <div className="user-information d-flex flex-wrap align-items-center">
                            <div className="fs-5 p-2  value-info">
                              {item.label}
                            </div>
                            <div className="p-1">:</div>
                            <div className="fs-5 p-2 text-start fw-bold value-text">
                              {item.value || ""}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    {showPDConversation && (
                      <>
                        <div className="col-sm-6 col-md-6">
                          <div className="d-flex flex-wrap align-items-center">
                            <div className="fs-5 value-info">
                              PD Conversation
                            </div>
                            <div className="p-1">:</div>
                            <div className="fs-5 p-2 text-start fw-bold value-text">
                              {publicDefenderDetailsResponse?.PDConversation
                                ? publicDefenderDetailsResponse?.PDConversation
                                : "-"}
                            </div>
                          </div>
                        </div>
                        {showFormStatus && (
                          <div className="col-sm-6 col-md-6">
                            <div className="d-flex flex-wrap align-items-center">
                              <div className="fs-5 p-2 value-info">
                                Form status
                              </div>
                              <div className="p-1">:</div>
                              <div className="fs-5 p-2 text-start fw-bold value-text">
                                {
                                  publicDefenderDetailsResponse?.RequestAssignStatus
                                }
                              </div>
                            </div>
                          </div>
                        )}

                        {/* {publicDefenderDetailsResponse?.PDStaffAcceptAssignReqest ===
                          1 ||
                          (publicDefenderDetailsResponse?.PDStaffRejectAssignReqest ===
                            1 && ( */}
                        {showResponseDate && (
                          <div className="col-sm-6 col-md-6">
                            <div className="d-flex flex-wrap align-items-center">
                              <div className="fs-5 p-2 value-info">
                                Response Date
                              </div>
                              <div className="p-1">:</div>
                              <div className="fs-5 p-2 text-start fw-bold value-text">
                                {
                                  publicDefenderDetailsResponse?.PDStaffAcceptOrRejectDate
                                }
                              </div>
                            </div>
                          </div>
                        )}

                        {/* {publicDefenderDetailsResponse?.PDStaffRejectAssignReqest ===
                          1 &&
                          publicDefenderDetailsResponse?.publicDefenderName !==
                            "" && ( */}
                        {showRejectedBy && (
                          <div className="col-sm-6 col-md-6">
                            <div className="d-flex flex-wrap align-items-center">
                              <div className="fs-5 p-2 value-info">
                                Rejected By
                              </div>
                              <div className="p-1">:</div>
                              <div className="fs-5 p-2 text-start fw-bold value-text">
                                {
                                  publicDefenderDetailsResponse?.PublicDefenderName
                                }
                              </div>
                            </div>
                          </div>
                        )}

                        {/* {publicDefenderDetailsResponse?.PDStaffRejectAssignReqest === */}
                        {rejectedReason && (
                          <div className="col-sm-6 col-md-6">
                            <div className="d-flex flex-wrap align-items-center">
                              <div className="fs-5 p-2 value-info">
                                Rejected Reason
                              </div>
                              <div className="p-1">:</div>
                              <div className="fs-5 p-2 text-start fw-bold value-text">
                                {
                                  publicDefenderDetailsResponse?.PDReqRejectReason
                                }
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    )}

                    {showPublicDefender &&
                      showPDConversation &&
                      !submittedFormList?.includes(formID) && (
                        <div className="clo-lg-12 w-100">
                          <SelectInput
                            label="Public Defender :"
                            cName={"w-25"}
                            options={GetPublicDefenderUserDropDownResponse}
                            handleChange={(e) => {
                              handlePublicDefenderChange(e);
                            }}
                            value={publicDefenderID}
                            isClearable={publicDefenderID}
                          />
                        </div>
                      )}

                    {/* )} */}
                    {showApproveRejectBtn &&
                      !showRejectReasonTextInput &&
                      showPDConversation &&
                      !submittedFormList?.includes(formID) && (
                        // UserRoleID === UserRoleType?.PublicDefender && (
                        <div className="col-md-12">
                          <div className="mt-2 d-flex flex-wrap justify-content-start align-items-center gap-2">
                            <Button
                              label="Accept"
                              status="success"
                              icon={"fa-solid fa-circle-check"}
                              type="button"
                              onClick={() => handleAccept()}
                            />

                            <Button
                              label="Reject"
                              status="primary"
                              icon={"fa-solid fa-xmark"}
                              type="button"
                              onClick={() => handleReject()}
                            />
                          </div>
                        </div>
                      )}

                    {showPDConversation &&
                      showRejectReasonTextInput &&
                      !submittedFormList?.includes(formID) && (
                        // publicDefenderDetailsResponse?.ReqAssignToPDUser !==
                        //   ManagementUserID) ||
                        // (publicDefenderDetailsResponse?.IsAssignToPDUser !== 1 &&
                        //   publicDefenderDetailsResponse?.PDStaffAcceptAssignReqest !==
                        //     1 &&
                        //   publicDefenderDetailsResponse?.IsAllowtoAccessOthersPDForm ===
                        //     false &&
                        <div className="col-md-12">
                          <div className="mt-2 d-flex flex-wrap justify-content-start align-items-center gap-2">
                            <TextInput
                              name="PDRequestRejectReason"
                              handleChange={(e) => handleRejectReasonChanges(e)}
                              errorMessage={errorMessage}
                            />

                            <Button
                              label="Submit"
                              status="primary"
                              type="button"
                              onClick={() => submitRejectReason()}
                            />
                          </div>
                        </div>
                      )}

                    {/* {publicDefenderDetailsResponse?.ReqAssignToPDUser !==
                      ManagementUserID &&
                      (publicDefenderDetailsResponse?.IsAssignToPDUser !== 1 ||
                        publicDefenderDetailsResponse?.PDStaffAcceptAssignReqest !==
                          1 ||
                        publicDefenderDetailsResponse?.IsAllowtoAccessOthersPDForm ===
                          false) && ( */}
                    <div className="col-md-12">
                      <div className="mt-4 d-flex flex-wrap justify-content-start align-items-center gap-2">
                        {showAssignBtn &&
                          showPDConversation &&
                          !submittedFormList?.includes(formID) && (
                            <Button
                              label="Assign"
                              status="primary"
                              icon={"fa-solid fa-user-plus"}
                              type="button"
                              onClick={() => handleAssign()}
                            />
                          )}

                        {showSelfAssignBtn && showPDConversation && (
                          // !submittedFormList?.includes(formID) &&
                          <div>
                            {/* {!showAssignBtn && <b>Public Defender :</b>} */}
                            <Button
                              label="Self Assign"
                              status="success"
                              icon={"fa-solid fa-hand-pointer"}
                              type="button"
                              onClick={() => handleSelfAssign()}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    {/* )} */}

                    <>
                      {showReplyModal &&
                        publicDefenderDetailsResponse?.RequestCurrentStatus !==
                        "Closed" && (
                          <>
                            <div className="details-legal d-flex flex-wrap  border-0">
                              <span className="mb-0 request-form-label">
                                Reply Mode
                              </span>
                              <RadioInput
                                name="postType"
                                id="postType"
                                options={ReplyMode}
                                handleChange={(e) => handleChange(e)}
                                selectedValue={
                                  publicDefenderFormPayloadData?.postType
                                }
                              />
                            </div>

                            <div className="details-legal">
                              {(publicDefenderFormPayloadData?.postType === 1 ||
                                publicDefenderFormPayloadData?.postType ===
                                3) && (
                                  <TextAreaInput
                                    placeholder="Enter Your Description"
                                    name="pdFormPostBody"
                                    handleChange={(e) => handleChange(e)}
                                    value={
                                      publicDefenderFormPayloadData?.pdFormPostBody ||
                                      ""
                                    }
                                    errorMessage={errorMessage}
                                    handleBlur={(e) => {
                                      handleValidation(e, "pdFormPostBody");
                                    }}
                                    maxLength={2000}
                                  />
                                )}
                              {(publicDefenderFormPayloadData?.postType === 2 ||
                                publicDefenderFormPayloadData?.postType ===
                                3) && (
                                  <FileInput
                                    acceptFormat=".pdf"
                                    name="file"
                                    id="fileInput"
                                    handleFileChange={(e) => handleChange(e)}
                                    errorMessage={errorMessage}
                                  />
                                )}
                            </div>

                            <div className="details-legal border-0">
                              <CheckBoxInput
                                name="activeStatus"
                                id="activeStatus"
                                label="Close"
                                handleClick={(e) => handleChange(e)}
                                checked={
                                  publicDefenderFormPayloadData?.activeStatus
                                }
                              />
                            </div>
                            <div className="pb-3 gap-3 d-flex flex-wrap justify-content-start align-items-center">
                              <Button
                                label="Submit"
                                status="success"
                                icon={"fa-solid fa-floppy-disk"}
                                type="button"
                                onClick={() => submitRequestFormInfo()}
                                title={"Submit"}
                              />
                              <Button
                                label="Reset"
                                title="Reset"
                                icon={"fa-solid fa-rotate-right"}
                                status="secondary"
                                type="button"
                                onClick={() => handleFormReset()}
                              />
                            </div>
                          </>
                        )}
                      {publicDefenderDetailsResponse?.PDStaffAcceptAssignReqest ===
                        1 &&
                        showThreadListTable && (
                          <>
                            <div className="m-3 gap-3 d-flex flex-wrap mobile-left align-items-center">
                              <Button
                                label="Traducir al español"
                                title="Traducir al español"
                                status="btn-label"
                                type="button"
                                className={"w-max"}
                                icon={"language"}
                                onClick={() => setselectLang("es")}
                              />

                              <Button
                                label="Translate to English"
                                title="Translate to English"
                                status="btn-label"
                                type="button"
                                className={"w-max"}
                                icon={"globe"}
                                onClick={() => setselectLang("en")}
                              />
                              <Button
                                label="Reset"
                                title="Reset"
                                icon={"fa-solid fa-rotate-right"}
                                status="btn-label"
                                type="button"
                                onClick={() => setselectLang("")}
                              />
                              <ExcelExport
                                variant="soft-gray"
                                handleExcelExport={exportRequestForm}
                              />
                            </div>
                            <div ref={componentRef1}>
                              {/* {showThreadListTable && ( */}
                              <Table
                                columns={column}
                                data={
                                  LoadInmateRequestPublicDefenderThreadPostResponse?.DataList
                                }
                                pagination
                                onChangeRowsPerPage={handleRowPerPage}
                                onChangePage={handlePageChange}
                                totalRowCount={
                                  LoadInmateRequestPublicDefenderThreadPostResponse?.TotalRecordCount
                                }
                                currentPage={requestFormTable?.pageNo}
                                paginationPerPage={
                                  requestFormTable.rowCountPerPage
                                }
                              />
                              {/* )} */}

                            </div>
                          </>
                        )}
                    </>
                  </article>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default React.memo(PublicDefenderForm);
